import React, { FC, useEffect, useState } from "react";

const LoginCarouselData = [
    // {
    //     title: "One platform for all your alternate investments",
    //     image: `${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/icmLoginGenricImage1.webp`,
    // },
    {
        title: "Invest in the best Unlisted Shares",
        description: "Get started with just 1 share",
        image: `${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/icmLoginGenricImage3.webp`,
    },
    {
        title: "Confirm your purchase today & get rewarded",
        image: `${process.env.ICM_PUBLIC_ASSETS_URL}images/webp/icmLoginGenricImage2.webp`,
    },
];

interface LoginImageCarouselProps {
    autoPlay?: boolean;
    slideInterval?: number;
    isFrozen?: boolean; // NEW PROP: Controls whether carousel should be frozen
}

const SLIDE_TIMEOUT = 4000;
const DEFAULT_ACTIVE_SLIDE = 0;

const LoginImageCarousel: FC<LoginImageCarouselProps> = ({
    autoPlay = true,
    slideInterval = SLIDE_TIMEOUT,
    isFrozen = false, // NEW PROP: Default to false (not frozen)
}) => {
    const [activeSlide, setActiveSlide] = useState<number>(DEFAULT_ACTIVE_SLIDE);
    const [carouselData] = useState(LoginCarouselData);

    useEffect(() => {
        // MODIFIED: When frozen, immediately move to first slide and stop auto-play
        if (isFrozen) {
            setActiveSlide(0); // Force move to first slide
            return; // Stop any further processing
        }

        // Normal auto-play logic when not frozen
        if (!autoPlay || carouselData.length === 0) return;

        const interval = setInterval(() => {
            setActiveSlide((prevSlide) => (prevSlide + 1) % carouselData.length);
        }, slideInterval);

        return () => clearInterval(interval);
    }, [carouselData.length, autoPlay, slideInterval, isFrozen]); // Added isFrozen to dependencies

    const handleDotNavigation = (slideIndex: number) => {
        // MODIFIED: Disable manual navigation when frozen
        if (isFrozen) return;
        setActiveSlide(slideIndex);
    };

    if (carouselData.length === 0) return null;

    return (
        <div
            id="login-image-carousel"
            className="login-carousel flex h-screen w-full flex-col items-center justify-between px-4 py-8 md:px-0 md:py-0"
        >
            {/* Single slide container */}
            <div className="flex w-full flex-1 items-center justify-center overflow-hidden p-0 md:p-6">
                <div
                    className="flex w-full transition-transform duration-700 ease-in-out"
                    style={{ transform: `translateX(-${activeSlide * 100}%)` }}
                >
                    {carouselData.map((slide, index) => (
                        <div
                            key={index}
                            className="flex w-full flex-shrink-0 flex-col items-center px-4"
                        >
                            {/* Text Block (Title + Description aligned together) */}
                            <div className="w-[70%] text-left">
                                <h3
                                    className="text-xl font-light leading-tight tracking-[-0.02em] text-white md:text-4xl"
                                    dangerouslySetInnerHTML={{ __html: slide.title }}
                                />

                                {slide.description && (
                                    <p
                                        className="mb-2 max-w-lg text-lg text-white md:text-lg"
                                        dangerouslySetInnerHTML={{ __html: slide.description }}
                                    />
                                )}
                            </div>

                            {/* Slide Image */}
                            <div className="mt-12 overflow-hidden">
                                <img
                                    src={slide.image}
                                    alt={slide.title}
                                    className="h-64 w-full max-w-md object-contain md:h-80 md:max-w-lg"
                                    onError={(e) => {
                                        e.currentTarget.src = "/images/login-placeholder.jpg";
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Carousel Navigation Dots */}
            <div id="carousel-navigation" className="mb-12 flex flex-row justify-center gap-2">
                {carouselData.map((_, slideIndex) => (
                    <button
                        key={slideIndex}
                        id={`carousel-dot-${slideIndex}`}
                        className={`h-3 w-3 rounded-full transition-all duration-300 ${
                            slideIndex === activeSlide
                                ? "scale-110 bg-white"
                                : "bg-neutralOpacityDark-15 hover:bg-gray-400"
                        } ${isFrozen ? "cursor-not-allowed opacity-60" : "cursor-pointer"}`} // MODIFIED: Change cursor and opacity when frozen
                        onClick={() => handleDotNavigation(slideIndex)}
                        aria-label={`Go to slide ${slideIndex + 1}`}
                        type="button"
                        disabled={isFrozen} // MODIFIED: Disable button when frozen
                    />
                ))}
            </div>
        </div>
    );
};

export default LoginImageCarousel;
